import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'
import type { AssetTypeEnum } from './AssetTypeEnum'

@ObjectType()
@InputType('AssetInput')
export class Asset {
  @Field(() => ID)
  @Prop({ type: String, default: () => generateEntityId('ast') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  url: string

  /**
   * There is a resolver for this that automatically gets the thumbnail for the image width: 150px
   */
  @Field(() => String)
  thumbUrl: string

  /**
   * Image width: 320px
   */
  @Field(() => String)
  smallUrl: string

  /**
   * Image width: 420px
   */
  @Field(() => String)
  mediumUrl: string

  /**
   * Image width: 1280px
   */
  @Field(() => String)
  largeUrl: string

  /**
   * Image width: 2560px
   */
  @Field(() => String)
  XLargeUrl: string

  @Field(() => String)
  @Prop({ type: String })
  type: AssetTypeEnum

  @Field(() => String)
  @Prop({ type: String })
  title: string

  @Field(() => String)
  @Prop({ type: String })
  subtitle: string
}
